(function() { window.GUID_f94553cf_1d12_4c20_a4e1_f260527dbfef = { getGuid: function() { return "f94553cf-1d12-4c20-a4e1-f260527dbfef"; } }; })();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var CS;
(function (CS) {
    let PopState;
    (function (PopState) {
        let isFromPop;
        let popCallbacks;
        let lastUrl;
        function getPopStateListenersLength() {
            if (popStateListenersDoesntExist()) {
                return 0;
            }
            let popStateListeners = JSON.parse(sessionStorage['popStateListeners']);
            return popStateListeners.length;
        }
        PopState.getPopStateListenersLength = getPopStateListenersLength;
        function popStateListenersDoesntExist() {
            return sessionStorage['popStateListeners'] == null || sessionStorage['popStateListeners'] == '{}' || sessionStorage['popStateListeners'] == '[]';
        }
        function popStateListenersPopAsync() {
            return __awaiter(this, void 0, void 0, function* () {
                if (popStateListenersDoesntExist()) {
                    return null;
                }
                let popStateListeners = JSON.parse(sessionStorage['popStateListeners']);
                let result = popStateListeners.pop();
                setPopStateListeners(popStateListeners);
                if (result.popCallbackId) {
                    if (popCallbacks) {
                        popCallbacks.forEach(o => { if (o.id == result.popCallbackId) {
                            result.callback = o.callback;
                        } });
                    }
                    else {
                        //We come back from another site probably, clear the popup states
                        yield removePopupPopStatesAsync();
                    }
                }
                return result;
            });
        }
        function popStateListenersPush(iPop) {
            let popStateListeners;
            if (popStateListenersDoesntExist()) {
                popStateListeners = new Array();
            }
            else {
                popStateListeners = JSON.parse(sessionStorage['popStateListeners']);
            }
            //Need to store callback and map it back
            if (!popCallbacks) {
                popCallbacks = new Array();
            }
            if (iPop.callback) {
                let popCallback = { id: iPop.id, callback: iPop.callback };
                iPop.popCallbackId = popCallback.id;
                popCallbacks.push(popCallback);
            }
            popStateListeners.push(iPop);
            setPopStateListeners(popStateListeners);
            if (iPop.newUrl && !onlyMyFirstLevelPagesInHistory()) {
                log('push - show back button ' + $('#button-back').length);
                $('#button-back').removeClass('hide');
            }
        }
        function setPopStateListeners(popStateListeners) {
            sessionStorage['popStateListeners'] = JSON.stringify(popStateListeners);
            log('history.state ' + JSON.stringify(history.state));
            log(sessionStorage['popStateListeners']);
        }
        function getLastPushWithoutPopIt() {
            if (popStateListenersDoesntExist()) {
                return null;
            }
            let popStateListeners = JSON.parse(sessionStorage['popStateListeners']);
            return popStateListeners[popStateListeners.length - 1];
        }
        function getIndexOfPop(id) {
            if (popStateListenersDoesntExist()) {
                return 0;
            }
            let popStateListeners = JSON.parse(sessionStorage['popStateListeners']);
            for (var i = 0; i < popStateListeners.length; i++) {
                if (popStateListeners[i].id == id) {
                    return i;
                }
            }
            return 0;
        }
        function onlyMyFirstLevelPagesInHistory() {
            if (popStateListenersDoesntExist()) {
                return true;
            }
            let popStateListeners = JSON.parse(sessionStorage['popStateListeners']);
            return popStateListeners.every(o => o.isMyFirstLevelPage);
        }
        function getHistoryState(id, isPopup, popupId, obsolete) {
            return JSON.stringify({ id, isPopup, obsolete, popupId });
        }
        function OnNavigation(url = null, replaceUrl = false, callback = null) {
            (() => __awaiter(this, void 0, void 0, function* () { return yield pushAsync(url, replaceUrl, callback, null); }))();
        }
        PopState.OnNavigation = OnNavigation;
        function WaitForPop(popupId, callback) {
            (() => __awaiter(this, void 0, void 0, function* () { return yield pushAsync(null, false, callback, popupId); }))();
        }
        PopState.WaitForPop = WaitForPop;
        function log(text) {
            if (CS.CommonData.Current && CS.CommonData.Current.IsDebug()) {
                CS.Helper.logWithColor("popstate", "gray", text);
            }
            //let l = Debug.GroupedLog.Get("PopState", "PopState", true, false);
            //l.Info("popstate: " + text);
        }
        function getIPop(newUrl, oldUrl, replaceState, callback, popupId) {
            var _a, _b;
            let isMyFirstLevelPage = false;
            let query = CS.Helper.GetQueryStringVars(newUrl);
            //if (CommonData.Current && query.get('walltype') &&
            //    query.get('personaid') == 'u' + CommonData.Current.UserId) {
            //    switch (query.get('walltype').toLowerCase()) {
            //        case 'eventwall':
            //        case 'pinswall':
            //        case 'statswall':
            //        case 'matches':
            //        case 'opponentswall':
            //        case 'opponents':
            //        case 'leaderboard':
            //        case 'messages':
            //        case 'videostreams':
            //            isMyFirstLevelPage = true;
            //    }
            //}
            //TODO: dotnetcore - verifier si on peut enlever le /app/ et /app
            if ((newUrl !== null && newUrl !== void 0 ? newUrl : "").endsWith('/app/') || (newUrl !== null && newUrl !== void 0 ? newUrl : "").endsWith('/app')) {
                isMyFirstLevelPage = true;
            }
            let positionLastShown = Number((_b = (_a = getLastPushWithoutPopIt()) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : 0);
            //if (!replaceState) {
            positionLastShown++;
            //}
            let ipop = {
                id: positionLastShown,
                oldUrl: oldUrl,
                newUrl: newUrl,
                isMyFirstLevelPage: isMyFirstLevelPage,
                callback: callback,
                popupId: popupId
            };
            return ipop;
        }
        function pushAsync() {
            return __awaiter(this, arguments, void 0, function* (newUrl = null, replaceUrl = false, callback = null, popupId) {
                let oldUrl = null;
                if (newUrl) {
                    if (newUrl.startsWith(window.location.origin)) {
                        newUrl = newUrl.substr(window.location.origin.length);
                    }
                    oldUrl = window.location.href.substr(window.location.origin.length);
                }
                //if (oldUrl && oldUrl.indexOf(newUrl) > -1) {
                //    /*Ici, un cas particulier arrivait et cest pourquoi cette patch. Dans le fond, en allant sur MatchDetails, affiche la matchcard
                //     ensuite, ouvre le dropdown d'option, referme le dropdown d'option, ensuite, fait back, ensuite reaffiche la matchcard et fait back. Sans cette patch
                //    le premier back ne marche pas, ca prenait un 2e back*/
                //    return;
                //}
                CS.DOM.$body.offon('sectionmasterreplaced.popstate', () => {
                    if (newUrl && !onlyMyFirstLevelPagesInHistory()) {
                        log('push - show back button ' + $('#button-back').length);
                        $('#button-back').removeClass('hide');
                    }
                });
                let ipop = getIPop(newUrl, oldUrl, replaceUrl, callback, popupId);
                if (newUrl && !replaceUrl) {
                    yield removePopupPopStatesAsync();
                }
                //Remove dummyDate to prevent adding same url to popstate
                if (newUrl) {
                    let newUrlQuery = CS.Helper.GetQueryStringVars(newUrl);
                    newUrlQuery.delete('dummydate');
                    newUrl = CS.Helper.ReplaceQueryString(newUrl, newUrlQuery);
                }
                if (oldUrl) {
                    let oldUrlQuery = CS.Helper.GetQueryStringVars(oldUrl);
                    oldUrlQuery.delete('dummydate');
                    oldUrl = CS.Helper.ReplaceQueryString(oldUrl, oldUrlQuery);
                }
                if (newUrl && newUrl.toLowerCase() == (oldUrl === null || oldUrl === void 0 ? void 0 : oldUrl.toLowerCase())) {
                    //Ne pas ajouter si c'est le meme url
                    log("same url, don't add it - " + newUrl);
                    return;
                }
                if (replaceUrl) {
                    let oldPop = yield popStateListenersPopAsync();
                    if (oldPop) {
                        if (oldPop.newUrl == null) {
                            log('replaceUrl for popup');
                            // pour une popup, on clear les popup states
                            yield removePopupPopStatesAsync();
                            oldPop = yield popStateListenersPopAsync();
                            //replaceUrl = false;
                        }
                        ipop.oldUrl = oldPop.oldUrl;
                        log('pop.oldUrl = ' + ipop.oldUrl);
                    }
                }
                popStateListenersPush(ipop);
                let isPopup = newUrl == null;
                let id = ipop.id;
                if (newUrl && replaceUrl) {
                    log("replacestate " + newUrl);
                    window.history.replaceState(getHistoryState(id, isPopup, popupId), '', newUrl);
                }
                else {
                    log("pushstate isPopup: " + isPopup + "  id: " + id + "   popupId: " + popupId + "   url:" + newUrl);
                    //sessionStorage.setItem('positionLastShown', String(id));
                    if (isPopup) {
                        window.history.pushState(getHistoryState(id, isPopup, popupId), '');
                    }
                    else {
                        window.history.pushState(getHistoryState(id, isPopup, popupId), '', newUrl);
                    }
                }
                return ipop;
            });
        }
        function popAsync(event) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b;
                log("pop " + getPopStateListenersLength() + ' ' + (history === null || history === void 0 ? void 0 : history.state) + " " + (event === null || event === void 0 ? void 0 : event.eventPhase));
                const direction = reorient();
                const fromBackButton = sessionStorage['app-button-back'] == 'true';
                sessionStorage['app-button-back'] = null;
                if (getPopStateListenersLength() > 0) {
                    let state = JSON.parse(history.state);
                    //if (state.obsolete === true) {
                    //    log('Removing duplicate popstate');
                    //    window.history.back();
                    //}
                    let currentPopState = getLastPushWithoutPopIt();
                    if (currentPopState.id < state.id) {
                        //C'est un forward
                        log('Forward');
                        let ipop = getIPop(window.location.href.substr(window.location.origin.length), currentPopState.newUrl, false, null, null);
                        popStateListenersPush(ipop);
                        CS.Nav.Go(ipop.newUrl, null, CS.Nav.Source.Standard, true);
                        return;
                    }
                    currentPopState = yield popStateListenersPopAsync();
                    //If back more than 1, make sure to synchronise
                    while (getIndexOfPop(currentPopState.id) > getIndexOfPop(state.id) + 1) {
                        currentPopState = yield popStateListenersPopAsync();
                    }
                    //This is to prevent Forward
                    //https://stackoverflow.com/questions/11548558/html5-history-disabling-forward-button/52609108#52609108
                    //window.history.replaceState(getHistoryState(currentPopState.id, currentPopState.newUrl == null, true), '');
                    //window.history.pushState(JSON.stringify(state), '');
                    if (currentPopState.callback) {
                        log('before callback');
                        isFromPop = true;
                        currentPopState.callback();
                        isFromPop = false;
                        if (CS.CommonData.Current.IsNativeApp) {
                            //TODO: est-ce qu'on leve le event si oldUrl est null
                            CS.NativeApp.NA_Navigated(currentPopState.oldUrl);
                        }
                    }
                    else /*if (direction != -1 || fromBackButton)*/ { //Ne pas faire go sur un back du bouton du browser
                        log('before Go ' + currentPopState.oldUrl);
                        let url = (_b = (_a = currentPopState.oldUrl) !== null && _a !== void 0 ? _a : currentPopState.newUrl) !== null && _b !== void 0 ? _b : CS.Url.BaseUrl();
                        CS.Nav.Go(url, null, CS.Nav.Source.Pop);
                    }
                }
                else {
                    if (window.location.href == lastUrl) {
                        log('forcePop sameUrl');
                        forcePop();
                    }
                    else if (JSON.parse(window.history.state).isPopup) {
                        log('forcePop internal');
                        forcePop();
                    }
                    else {
                        log('Go');
                        CS.Nav.Go(window.location.href, null, CS.Nav.Source.Pop);
                    }
                }
            });
        }
        function removePopupPopStatesAsync() {
            return __awaiter(this, void 0, void 0, function* () {
                if (window.onpopstate == null) {
                    return;
                }
                window.onpopstate = null;
                log('Clear all popup popstates');
                let state = JSON.parse(history.state);
                let ipop = getLastPushWithoutPopIt();
                while (state && (state.isPopup || (ipop && !ipop.newUrl))) {
                    //debugger;
                    let waitingForPopForRemoval = false;
                    if (!ipop) {
                        log('Clearing popup !pop');
                        waitingForPopForRemoval = true;
                        window.history.back();
                    }
                    else if (state.id == ipop.id) {
                        log('Clearing popup pop == state');
                        waitingForPopForRemoval = true;
                        window.history.back();
                        yield popStateListenersPopAsync();
                    }
                    else if (state.id > ipop.id) {
                        log(`Clearing popup pop ${ipop.id} < state ${state.id}`);
                        //Let's wait to be sure the state is not just changed
                        waitingForPopForRemoval = true;
                        window.history.back();
                    }
                    else if (state.id < ipop.id) {
                        log(`Clearing popup pop ${ipop.id} > state ${state.id}`);
                        yield popStateListenersPopAsync();
                    }
                    let newipop = getLastPushWithoutPopIt();
                    let newState = JSON.parse(history.state);
                    if (waitingForPopForRemoval && newState && state && newState.id == state.id) {
                        log('waitingForPopForRemoval');
                        let now = new Date().getTime();
                        const sleepDuration = 2000;
                        while ((new Date().getTime() < now + sleepDuration)
                            && newState && (newState.id == state.id)) {
                            yield new Promise(r => setTimeout(r, 20));
                            newState = JSON.parse(history.state);
                        }
                        log('finished waitingForPopForRemoval ' + ((newState === null || newState === void 0 ? void 0 : newState.id) == (state === null || state === void 0 ? void 0 : state.id)));
                    }
                    if (newState && newState.id == (state === null || state === void 0 ? void 0 : state.id)
                        && ((newipop == null && ipop == null) || (newipop && ipop && newipop.id == ipop.id))) {
                        log('state and pop hasnt changed');
                        break;
                    }
                    state = newState;
                    ipop = newipop;
                }
                window.onpopstate = popAsync;
            });
        }
        function forcePop() {
            log("forcePop " + window.location.href);
            lastUrl = window.location.href;
            if (CS.CommonData.Current.IsNativeApp) {
                CS.NativeApp.NA_Navigated(lastUrl);
            }
            window.history.back();
        }
        function GoBackIfNotAlreadyDone() {
            log("GoBackIfNotAlreadyDone isFromPop:" + isFromPop);
            let lastPop = getLastPushWithoutPopIt();
            if (lastPop && lastPop.newUrl == null) {
                log("GoBackIfNotAlreadyDone going back");
                //popStateListeners.pop();
                window.history.back();
            }
            //Need to do this since onpopstate not triggered if no interaction
            //    if (isFromPop || !lastPop) {
            //        return;
            //    }
            //    if (lastPop.oldUrl == null) {
            //        window.onpopstate = null;
            //        let currentPopState = await popStateListenersPop();
            //        window.history.back();
            //        if (currentPopState.callback) {
            //            log('before callback');
            //            isFromPop = true;
            //            currentPopState.callback();
            //            isFromPop = false;
            //            if (CS.CommonData.Current.IsNativeApp) {
            //                //TODO: est-ce qu'on leve le event si oldUrl est null
            //                Navigated(currentPopState.oldUrl);
            //            }
            //        }
            //        else /*if (direction != -1 || fromBackButton)*/ { //Ne pas faire go sur un back du bouton du browser
            //            log('before Go');
            //            CS.Nav.Go(currentPopState.oldUrl, null, Nav.Source.Pop);
            //        }
            //        window.onpopstate = pop;
            //    }
        }
        PopState.GoBackIfNotAlreadyDone = GoBackIfNotAlreadyDone;
        function reorient() {
            var _a, _b;
            let positionLastShown = Number((_b = (_a = getLastPushWithoutPopIt()) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : 0);
            let state = JSON.parse(history.state); // Absolute position in stack
            if (history.state === null) { // Meaning a new entry on the stack
                let ipop = getIPop(window.location.href, null, false, null, null);
                state = { id: ipop.id, isPopup: false, popupId: null }; // Top of stack
                // (1) Stamp the entry with its own position in the stack
                history.replaceState(JSON.stringify(state), '');
                popStateListenersPush(ipop);
            }
            else if (state.isPopup) {
                //Back de popup
                return 0;
            }
            log('stack position: ' + JSON.stringify(state) + '  last: ' + positionLastShown);
            //if (!onlyMyFirstLevelPagesInHistory()) {
            //    log('push - show back button ' + $('#button-back').length);
            //    $('#button-back').removeClass('hide');
            //}
            // (2) Keep track of the last position shown
            //sessionStorage.setItem('positionLastShown', String(state.id));
            // (3) Discover the direction of travel by comparing the two
            const diff = state.id - positionLastShown;
            const direction = diff < 0 ? -1 : diff > 0 ? 1 : 0;
            log('Travel direction is ' + direction);
            // One of backward (-1), reload (0) and forward (1)
            return direction;
        }
        function pageshow() {
            let dir = reorient();
            log('pageshow - ' + dir + ' ' + window.location.href);
            const pageAccessedByReload = ((window.performance.navigation && window.performance.navigation.type === 1) ||
                (window.performance.getEntriesByType('navigation')
                    && window.performance.getEntriesByType('navigation').length > 0
                    && window.performance.getEntriesByType('navigation')[0].type == 'reload'));
            if (pageAccessedByReload) {
                //Pas besoin de await ici
                removePopupPopStatesAsync();
            }
        }
        function beforeUnload() {
            removePopupPopStatesAsync();
            return;
        }
        function bindEvents() {
            //C'est cet event qui est appelé lorsque window.location.back() est appelé ou que le browser fait BACK/FOWARD
            window.onpopstate = () => setTimeout(popAsync, 0);
            window.onpageshow = pageshow;
            window.onbeforeunload = beforeUnload;
            $(document).keyup(function (e) {
                if (e.keyCode === CS.Enums.KeyCode.Escape) {
                    let lastPop = getLastPushWithoutPopIt();
                    if (lastPop && !lastPop.newUrl) {
                        forcePop();
                    }
                }
            });
        }
        bindEvents();
    })(PopState = CS.PopState || (CS.PopState = {}));
})(CS || (CS = {}));

//# sourceMappingURL=cs-popstate.js.map
